"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchNotificationsById = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.patchNotificationsById = (0, sonar_http_1.createPatchEndpoint)((request) => `/api/v3/notifications/${request === null || request === void 0 ? void 0 : request.id}`, {
    requestTransform: (request) => (Object.assign({ isRead: true }, request))
});
//# sourceMappingURL=patchNotificationsById.js.map